module.exports = {
      id: "icons:envelope-usage",
      viewBox: "0 0 17 15",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:envelope-usage",
      toString: function () {
        return this.url;
      }
    }